import { render, staticRenderFns } from "./communicationDialog.vue?vue&type=template&id=7d677637"
import script from "./communicationDialog.vue?vue&type=script&lang=ts"
export * from "./communicationDialog.vue?vue&type=script&lang=ts"
import style0 from "./communicationDialog.vue?vue&type=style&index=0&id=7d677637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports